import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { propArrayShape, propFunc, propNumber, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitExperiencedHeader from './ProfessionalUnitExperiencedHeader';
import ProfessionalUnitExperiencedIndustries from './ProfessionalUnitExperiencedIndustries';
import ProfessionalUnitExperiencedThemes from './ProfessionalUnitExperiencedThemes';
const ProfessionalUnitExperienced = (props) => {
    const { allIndustryClasses, allThemes, industryClasses: rawIndustryClasses, limit, showIndustriesModal, showThemesModal, themes: rawThemes, } = props;
    /**
     * 特に得意、経験あり、経験なしの順に並び替えつつ抽出する
     * @type {function(*=, *=, *): *}
     */
    const parseItems = useCallback((allList, list, key) => {
        const experiencedList = (list || []).map((raw) => (allList || []).find(({ id }) => id === raw[key]));
        const restList = (allList || []).filter((all) => !experiencedList.some(({ id }) => id === all.id));
        return experiencedList.concat(restList).slice(0, limit);
    }, [limit]);
    const industryClasses = useMemo(() => parseItems(allIndustryClasses, rawIndustryClasses, 'professionalOrganizationUnitIndustryClassId'), [allIndustryClasses, rawIndustryClasses, parseItems]);
    const themes = useMemo(() => parseItems(allThemes, rawThemes, 'professionalOrganizationUnitThemeId'), [rawThemes, allThemes, parseItems]);
    return (_jsxs("div", Object.assign({ className: 'unit_experienced' }, { children: [_jsx(ProfessionalUnitExperiencedHeader, {}), _jsx(ProfessionalUnitExperiencedIndustries, { industryClasses: industryClasses, onClickAll: showIndustriesModal }), _jsx(ProfessionalUnitExperiencedThemes, { onClickAll: showThemesModal, themes: themes })] })));
};
ProfessionalUnitExperienced.propTypes = {
    allIndustryClasses: propArrayShape().isRequired,
    allThemes: propArrayShape().isRequired,
    industryClasses: propArrayShape().isRequired,
    limit: propNumber().isRequired,
    showIndustriesModal: propFunc().isRequired,
    showThemesModal: propFunc().isRequired,
    themes: propArrayShape().isRequired,
};
export default ProfessionalUnitExperienced;
